import { createAction } from '@reduxjs/toolkit';



export const getmerchantsInfoRequest = createAction('GET_MERCHANTS_INFO', ({ pageNum, pageSize, sortBy, sortOrder, aggregator}) => {
    return{
        payload: {
			pageNum,
			pageSize, 
			sortBy, 
			sortOrder,
			aggregator
        }
    }
});

export const getmerchantsInfoSuccess = createAction('GET_MERCHANTSINFO_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getmerchantsInfoFailure = createAction('GET_MERCHANTSINFO_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});

export const saveAggregatorValues = createAction('AGGREGATOR_VALUES', (aggregators) => ({
	payload: { aggregators },
}));

export const activebrandnames= createAction('BRAND_NAME', (brandname) => ({ 
	payload: { brandname },
}));

export const activelocations = createAction('ACTIVE_LOCATIONS', (locations) => ({
	payload: { locations },
}));

export const activelocationslist = createAction('ACTIVE_LOCATIONS_LIST', (locationslist) => ({
	payload: { locationslist },
}));

export const activebusinessname = createAction('ACTIVE_BUSINESS_NAME', (businessName) => ({
	payload: { businessName },
}));

export const activeusername = createAction('ACTIVE_	USER_NAME', (username) => ({
	payload: { username },
}));

export const activeemail = createAction('ACTIVE_EMAIL', (email) => ({
	payload: { email },
}));

export const activebrandid = createAction('ACTIVE_BRANDID', (brandid) => ({
	payload: { brandid },
}));